__turbopack_context__.v({
  "audioPlayButton": "le4isW_audioPlayButton",
  "playButtonBase": "le4isW_playButtonBase",
  "videoBackground": "le4isW_videoBackground",
  "videoContainer": "le4isW_videoContainer",
  "videoPlayButton": "le4isW_videoPlayButton",
  "videoSpinner": "le4isW_videoSpinner",
});
